import { FormattedMessage } from 'react-intl'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  if (textOnly) {
    return <FormattedMessage
      id="fmQoCma2QV_Cs2oKJd4k"
      defaultMessage="View offer"
      
    />
  }

  if (variant === 'default') {
    return <CSSBreakpoint min="desktop">
      <TextButton kind="primary" nonInteractable>
        <FormattedMessage
          id="QRWBrCWyrfw5EkB88Ukz"
          defaultMessage="View"
          
        />
      </TextButton>
    </CSSBreakpoint>
  }

  return <TextButton kind="secondary" nonInteractable>
    <CSSBreakpoint as="span" max="tablet">
      <FormattedMessage
        id="D0v8mAmdy1sWaJg3dsiV"
        defaultMessage="View"
        
      />
    </CSSBreakpoint>
    <CSSBreakpoint as="span" min="desktop">
      <FormattedMessage
        id="fmQoCma2QV_Cs2oKJd4k"
        defaultMessage="View offer"
        
      />
    </CSSBreakpoint>
  </TextButton>
}
